module.exports = {"id":"183853","name":"Aarón Ñíguez","rating":"73","photo":"./data/images/photos/2/183853.png","club":{"name":"Real Oviedo","logo":"./data/images/clubs/RealOviedo.png"},"positions":["MG","MD","MOC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AaronNiguez0.json
// module id = 48
// module chunks = 0